import BaseService from './base.service'

class RoleService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/user/role', parameters)
  }
}

export default RoleService
